module.exports = __webpack_public_path__ + "static/media/404 image.bf78a45d.png";